(function () {
  function applyChoice(input) {
    if (!input || !input.matches('[data-color-customizer-input]')) return;
    var layer = input.getAttribute('data-layer');
    var targets = document.querySelectorAll('[data-color-customizer-layer="' + layer + '"]');
    Array.prototype.forEach.call(targets, function (target) {
      target.style.backgroundColor = input.getAttribute('data-hex');
    });
    var group = input.closest('[data-color-customizer-group]');
    var selected = group && group.querySelector('[data-color-customizer-selected]');
    if (selected) selected.textContent = input.value;
  }

  document.addEventListener('change', function (event) {
    applyChoice(event.target);
  });

  document.addEventListener('click', function (event) {
    var label = event.target.closest && event.target.closest('.color-customizer__swatch');
    if (!label) return;
    var input = document.getElementById(label.getAttribute('for'));
    if (!input) return;
    input.checked = true;
    applyChoice(input);
  });
})();
